import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "roofBoxFilled"
const RoofBoxFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M17.669 11.25C18.637 11.25 19.497 11.87 19.803 12.789L20.54 15H22.5C22.5 15.78 21.906 16.419 21.146 16.492L22.5 18.522V22.5H1.5V18.604L1.555 18.468 1.56 18.457 1.567 18.439 1.6 18.36 1.718 18.09C1.818 17.87 1.958 17.573 2.12 17.27 2.265 17 2.442 16.704 2.632 16.452 1.982 16.288 1.5 15.702 1.5 15H3.718C3.915 14.392 4.108 13.646 4.255 13.023 4.496 12.003 5.403 11.25 6.476 11.25zM4.5 20.625H8.25C8.25 19.382 7.243 18.375 6 18.375H4.5zM18 18.375C16.757 18.375 15.75 19.382 15.75 20.625H19.5V18.375zM6.476 12.75C6.122 12.75 5.801 13.002 5.714 13.369 5.555 14.04 5.338 14.893 5.106 15.586L5.049 15.75H19.209L18.38 13.263C18.278 12.957 17.992 12.75 17.67 12.75z"
            clipRule="evenodd"
          />
          <path d="M19.5 8.25C19.5 9.078 18.828 9.75 18 9.75H6C5.172 9.75 4.5 9.078 4.5 8.25V6.188H19.5zM16.763 1.5C17.355 1.5 17.893 1.85 18.133 2.39L19.321 5.064H4.68L5.867 2.39C6.107 1.849 6.644 1.5 7.237 1.5z" />
        </svg>
      }
    </span>
  )
}
export default RoofBoxFilledIcon
